module.exports = __webpack_public_path__ + "img/icon_filezip.4583b0c7.svg";